/*
 * Copyright (c) 2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React from 'react'
import {useTranslation} from 'react-i18next'
import {Link} from 'react-router-dom'
import clsx from 'clsx'
import UiAuthFormShell from 'components/Ui/UiAuthFormShell'
import UiInput from 'components/Ui/UiInput'
import UiButton, {UiButtonSize, UiButtonStyle, UiButtonType,} from 'components/Ui/UiButton'

interface RecoveryFormProps {
    onSubmit: (data) => void
    register: any
}

const ForgottenPasswordRecoveryForm = (props: RecoveryFormProps) => {
    const { t } = useTranslation()

    return (
        <UiAuthFormShell
            title={t('Password recovery')}
            subtitle={t(
                'To reset your password, enter the full email address that you use to log in.'
            )}
            footer={
                <div className={clsx('text-center')}>
                    <Link to={'/'}>
                        <span>{t('Back to main')}</span>
                    </Link>
                </div>
            }
        >
            <form
                autoComplete={'off'}
                className={clsx('w-full', 'space-y-3')}
                onSubmit={props.onSubmit}
            >
                <UiInput
                    label={t('Recovery email')}
                    type={'email'}
                    placeholder={t('Enter e-mail address')}
                    className={clsx('w-full')}
                    {...props.register('email')}
                    required
                />

                <div className={clsx('flex', 'justify-center', 'pt-2')}>
                    <UiButton
                        id={'btn-password-recovery-submit'}
                        style={UiButtonStyle.Primary}
                        size={UiButtonSize.Medium}
                        type={UiButtonType.Submit}
                        title={t('Reset password')}
                    />
                </div>
            </form>
        </UiAuthFormShell>
    )
}

export default ForgottenPasswordRecoveryForm